/**
 * "A new version is ready" (service worker waiting). The signal often fires at launch, before React has mounted
 * (the app waits for IndexedDB first), so it's remembered here and read on mount, not lost. Found on a Nokia
 * XR20, 14 Oct 2026: every launch logged app.update_ready, but no banner appeared, so the phone never updated.
 */
let ready = false;
const listeners = new Set<(v: boolean) => void>();

export function markUpdateReady(): void {
  ready = true;
  listeners.forEach((l) => l(true));
}

export function isUpdateReady(): boolean {
  return ready;
}

/** Subscribe; returns the unsubscribe. The current value is delivered at once. */
export function onUpdateReady(l: (v: boolean) => void): () => void {
  listeners.add(l);
  l(ready);
  return () => listeners.delete(l);
}
